import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
import shared from '../../../src/shared.js';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Screenshot = makeShortcode("Screenshot");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`To protect your packages, as a package publisher, you can require everyone who has write access to a package to have two-factor authentication (2FA) enabled. This will require that users provide 2FA credentials in addition to their login token when they publish the package. For more information, see "`}<a parentName="p" {...{
        "href": "configuring-two-factor-authentication"
      }}>{`Configuring two-factor authentication`}</a>{`".`}</p>
    <p>{`You may also choose to allow publishing with either two-factor authentication `}<em parentName="p">{`or`}</em>{` with `}<a parentName="p" {...{
        "href": "creating-and-viewing-access-tokens"
      }}>{`automation tokens`}</a>{`. This lets you configure automation tokens in a CI/CD workflow, but requires two-factor authentication from interactive publishes.`}</p>
    <h2>{`Configuring two-factor authentication`}</h2>
    <ol>
      <li parentName="ol">
        <>{shared['user-login'].text}</>
        <>{shared['user-login'].image}</>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Navigate to the package on which you want to require a second factor to publish or modify settings.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click `}<strong parentName="p">{`Settings`}</strong>{`.`}</p>
        <Screenshot src="/packages-and-modules/securing-your-code/2fa-package-admin.png" alt="Screenshot showing the admin tab on a package page" mdxType="Screenshot" />
      </li>
      <li parentName="ol">
        <p parentName="li">{`Under "Publishing access", select the requirements to publish a package.`}</p>
        <ol parentName="li">
          <li parentName="ol">
            <p parentName="li"><strong parentName="p">{`Two-factor authentication is not required`}</strong><br parentName="p"></br>{`
`}{`With this option, a maintainer can publish a package or change the package settings whether they have two-factor authentication enabled or not.  This is the least secure setting.`}</p>
          </li>
          <li parentName="ol">
            <p parentName="li"><strong parentName="p">{`Require two-factor authentication or automation tokens`}</strong><br parentName="p"></br>{`
`}{`With this option, maintainers must have two-factor authentication enabled for their account.  If they publish a package interactively, using the `}<inlineCode parentName="p">{`npm publish`}</inlineCode>{` command, they will be required to enter 2FA credentials when they perform the publish. However, maintainers may also create an `}<a parentName="p" {...{
                "href": "creating-and-viewing-access-tokens"
              }}>{`automation token`}</a>{` and use that to publish. A second factor is `}<em parentName="p">{`not`}</em>{` required when using an automation token, making it useful for continuous integration and continuous deployment workflows.`}</p>
          </li>
          <li parentName="ol">
            <p parentName="li"><strong parentName="p">{`Two-factor authentication only`}</strong><br parentName="p"></br>{`
`}{`With this option, a maintainer must have two-factor authentication enabled for their account, and they must publish interactively. Maintainers will be required to enter 2FA credentials when they perform the publish.`}</p>
          </li>
        </ol>
        <Screenshot src="/packages-and-modules/securing-your-code/2fa-package-require.png" alt="Screenshot showing the require two-factor option for a package" mdxType="Screenshot" />
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click `}<strong parentName="p">{`Update Package Settings`}</strong>{`.`}</p>
        <Screenshot src="/packages-and-modules/securing-your-code/2fa-package-update.png" alt="Screenshot showing the update package settings button" mdxType="Screenshot" />
      </li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      